import { useCallback, useState } from "react"
import { useFormAppRelay } from "./relay/FormAppRelay"
import { useFormDispatch } from "../redux/formStoreHooks"
import { submitStatusUpdates } from "../redux/submitStatusUpdates"
import { ConceptStatusValueType } from "@fusion-advantage/backcompat"

export const useFileUploader = () => {
	const { uploadFile } = useFormAppRelay()
	const [loading, setLoading] = useState<boolean>(false)
	const dispatch = useFormDispatch()
	const upload = useCallback(async (cid: string, file: File) => {
		setLoading(true)
		const result = await uploadFile({File: file})
		if(result) {
			dispatch(submitStatusUpdates([{
				cid,
				value: result.BlobName,
				valueType: ConceptStatusValueType.Chosen,
			}]))
		}
		setLoading(false)
	}, [setLoading, uploadFile, dispatch])
	const drop = useCallback((cid: string) => {
		dispatch(submitStatusUpdates([{
			cid: cid!,
			value: null,
			valueType: ConceptStatusValueType.Chosen,
		}]))
	}, [setLoading, uploadFile, dispatch])
	return {
		loading,
		upload,
		drop,
	}
}
